import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./detail.css";
import "../Designs/details2.css";
import TrendingPages from "../Designs/TrendingPages";
import Footer from "./Footer";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../Features/cart/cartslice";
import { MdReadMore } from "react-icons/md";
import { BsFillBookmarkHeartFill } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";

const DetailsPage = () => {
  const [movie, setMovie] = useState({});
  const [cast, setCast] = useState([]);
  const [alreadyPresentInCart, setAlreadyPresentInCart] = useState(false);
  const itemsInCart = useSelector((state) => state.cart.cart);
  const [alreadyInCartBtn, setAlreadyInCartBtn] = useState(false);
  // const { userid } = useParams();
  const { userid: movieId } = useParams();

  const dispatch = useDispatch();

  function addToWislist(product) {
    // Check if the movie is already in the cart
    const isMovieAlreadyAdded = itemsInCart.some(
      (item) => item.id === product.id
    );
    if (isMovieAlreadyAdded) {
      // Show a message or handle the duplicate case here
      setAlreadyInCartBtn(true);
      setAlreadyPresentInCart(true);
    } else {
      // Dispatch the addToCart action if the movie is not in the cart
      dispatch(addToCart(product));
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    fetch(
      `https://api.themoviedb.org/3/movie/${movieId}?api_key=375735221c3b7b45a786c79616eae571&language=en-US`
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setMovie(data);
      });
  }

  useEffect(() => {
    async function getCast() {
      const data = await fetch(
        `https://api.themoviedb.org/3/movie/${movieId}/credits?api_key=375735221c3b7b45a786c79616eae571&language=en-US`
      );
      const res = await data.json();
      setCast(res.cast);
    }

    getCast();
  }, []);

  return (
    <>
      {/* <div className="movie">
        <div className="movie-image">
          <img
            className="mov-img"
            src={`https://image.tmdb.org/t/p/original${movie.backdrop_path}`}
            alt="movie"
          />
        </div>
        <div className="synopsis">
          <p className="movie-name">{movie.original_title}</p>
          <div className="rating-votes">
            <i className="fa fa-star">
              {" "}
              {movie && movie.vote_average?.toFixed(1)}
            </i>
            <p className="votes">({movie.vote_count}) Votes</p>
            <p className="runtime">{movie.runtime} Mins</p>
          </div>
          <ul className="lists">
            <li className="list">
              {movie.genres &&
                movie.genres.map((genre) => (
                  <p key={movie.imdb_id} className="list-name">
                    {genre.name}
                  </p>
                ))}
            </li>
          </ul>
          <p className="para">{movie.overview}</p>
        </div>
      </div> */}

      {/* ************************ NEW DESIGNING ******************************* */}

      {
        <div
          className="detail_container"
          style={{
            backgroundImage: `linear-gradient(to right, rgb(24, 5, 40) calc((50vw - 170px) - 340px), rgba(53, 11, 32, 0.6) 50%, rgba(39, 7, 25, 1) 100%), url(https://image.tmdb.org/t/p/original${movie.backdrop_path})`,
            // background: `linear-gradient(to right, rgba(52.5, 10.5, 31.5, 1) calc((50vw - 170px) - 340px), rgba(52.5, 10.5, 31.5, 0.84) 50%, rgba(52.5, 10.5, 31.5, 0.84) 100%),url(https://image.tmdb.org/t/p/original${movie.backdrop_path})`,
            // backgroundSize: "contain",
            // backgroundPosition: "center",
          }}
        >
          <div className="detail-grid-box">
            {alreadyPresentInCart && (
              <div
                onClick={() => setAlreadyPresentInCart(false)}
                className="already-present-message-box"
              >
                <p>
                  Movie Already In Watchlist
                  <span onClick={() => setAlreadyPresentInCart(false)}>
                    <AiOutlineCloseCircle />
                  </span>
                </p>
              </div>
            )}
            <div className="detail-image-box">
              <img
                className="detail-img"
                src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                alt="movie"
              />
            </div>
            <div className="detail-content-box">
              <div className="detail_title_box">
                <p className="detail_title">{movie.original_title}</p>
                <p className="detail_runtime">({movie.runtime} Mins)</p>
              </div>
              <div className="detail-date-genre-box">
                <p className="detail-date">({movie.release_date})</p>
                {movie.genres &&
                  movie.genres.map((genre) => (
                    <ul>
                      <li className="detail-genres-name">{genre.name}</li>
                    </ul>
                  ))}
              </div>

              <div className="detail-ratings-box">
                <i className="fa fa-star">
                  &nbsp;{movie && movie.vote_average?.toFixed(1)}
                </i>
                <p className="detail-tagline">{movie.tagline}</p>
                <p
                  className="detail-status"
                  style={{
                    color: movie.status === "Released" ? "#63e6be" : " #f03e3e",
                  }}
                >
                  Status: {movie.status}
                </p>
              </div>
              <div className="detail-overview-box">
                <p className="over-view">Overview</p>
                <p className="detail-overview">{movie.overview}</p>
              </div>
              <div className="wishlist-btn-box">
                <button
                  onClick={() => addToWislist(movie)}
                  className="wishlist-btn"
                >
                  {alreadyInCartBtn
                    ? "Movie Added To Cart"
                    : "Add to Watchlist"}{" "}
                  <BsFillBookmarkHeartFill />
                </button>
                {alreadyInCartBtn ? (
                  <Link to="/watchlist" className="wishlist-btn go-wishlist">
                    Go To Watchlist
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      }
      {/* <TrendingPages /> */}
      <p className="top-cast-title">Top Cast</p>
      <div className="cast-container">
        {cast &&
          cast.slice(0, 10).map((cast) => (
            <div className="cast-box" key={cast.name}>
              <div className="cast-image-box">
                {cast.profile_path ? (
                  <img
                    className="cast-img"
                    src={`https://image.tmdb.org/t/p/original${cast.profile_path}`}
                    alt="images of cast"
                  />
                ) : (
                  <img
                    className="no-cast-img"
                    src={`https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-4-user-grey-d8fe957375e70239d6abdd549fd7568c89281b2179b5f4470e2e12895792dfa5.svg`}
                    alt="images of cast"
                  />
                )}
              </div>
              <div className="cast-name-box">
                <p className="cast-name">{cast.name}</p>
                <p className="cast-character">{cast.character}</p>
              </div>
            </div>
          ))}
        {cast.length > 10 ? (
          <div className="cast-view-more-box">
            <Link to={`/cast/${movieId}`}>
              View More
              <MdReadMore />
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default DetailsPage;
